// Portfolio data for AP Pacific website
import IMAGES from '../constants/images';

// Function to get translated portfolio items
export const getPortfolioItems = (t) => [
  {
    id: 'grout-cleaning',
    title: t('portfolioItems.groutCleaning.title'),
    category: t('portfolioItems.groutCleaning.category'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_20251107_153658.jpg',
    date: '4 Apr',
    likes: 146,
    description: t('portfolioItems.groutCleaning.description'),
    content: t('portfolioItems.groutCleaning.content'),
    additionalImages: [
      'https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_290411-scaled.jpg'
    ],
    beforeAfter: true,
    projectDetails: {
      [t('portfolioItems.projectDetailsLabels.client')]: t('portfolioItems.groutCleaning.client'),
      [t('portfolioItems.projectDetailsLabels.location')]: 'Montreal, QC',
      [t('portfolioItems.projectDetailsLabels.duration')]: '1 Day',
      [t('portfolioItems.projectDetailsLabels.serviceType')]: t('portfolioItems.groutCleaning.serviceType')
    }
  },
  {
    id: 'reception-hall-tile-grout',
    title: t('portfolioItems.receptionHallTileGrout.title'),
    category: t('portfolioItems.groutCleaning.category'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_20251107_153744.jpg',
    date: '7 Nov',
    likes: 152,
    description: t('portfolioItems.receptionHallTileGrout.description'),
    content: t('portfolioItems.receptionHallTileGrout.content'),
    beforeAfter: true,
    projectDetails: {
      [t('portfolioItems.projectDetailsLabels.client')]: t('portfolioItems.receptionHallTileGrout.title'),
      [t('portfolioItems.projectDetailsLabels.location')]: 'Montreal, QC',
      [t('portfolioItems.projectDetailsLabels.duration')]: '1 Day',
      [t('portfolioItems.projectDetailsLabels.serviceType')]: t('portfolioItems.groutCleaning.serviceType')
    }
  },
  {
    id: 'hotel-staircase-tile-cleaning',
    title: t('portfolioItems.hotelStaircaseTileCleaning.title'),
    category: t('portfolioItems.groutCleaning.category'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_32771-scaled.jpg',
    date: '9 Nov',
    likes: 165,
    description: t('portfolioItems.hotelStaircaseTileCleaning.description'),
    content: t('portfolioItems.hotelStaircaseTileCleaning.content'),
    beforeAfter: true,
    projectDetails: {
      [t('portfolioItems.projectDetailsLabels.client')]: 'Hotel',
      [t('portfolioItems.projectDetailsLabels.location')]: 'Montreal, QC',
      [t('portfolioItems.projectDetailsLabels.duration')]: '1 Day',
      [t('portfolioItems.projectDetailsLabels.serviceType')]: t('portfolioItems.groutCleaning.serviceType')
    }
  },
  {
    id: 'truck-mount-carpet-cleaning-machine',
    title: t('portfolioItems.truckMount.title'),
    category: t('portfolioItems.truckMount.category'),
    image: IMAGES.equipment.prochemEverest,
    date: '4 Apr',
    likes: 143,
    description: t('portfolioItems.truckMount.description'),
    content: t('portfolioItems.truckMount.content'),
    beforeAfter: false,
    projectDetails: {
      [t('portfolioItems.projectDetailsLabels.equipment')]: t('portfolioItems.truckMount.equipment'),
      [t('portfolioItems.projectDetailsLabels.power')]: t('portfolioItems.truckMount.power'),
      [t('portfolioItems.projectDetailsLabels.capacity')]: t('portfolioItems.truckMount.capacity'),
      [t('portfolioItems.projectDetailsLabels.serviceType')]: t('portfolioItems.truckMount.serviceType')
    }
  },
  {
    id: 'emergency-flood-service',
    title: t('portfolioItems.emergencyFlood.title'),
    category: t('portfolioItems.emergencyFlood.category'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_20251101_124858-3-scaled.jpg',
    date: '4 Apr',
    likes: 157,
    description: t('portfolioItems.emergencyFlood.description'),
    content: t('portfolioItems.emergencyFlood.content'),
    beforeAfter: true,
    projectDetails: {
      [t('portfolioItems.projectDetailsLabels.responseTime')]: t('portfolioItems.emergencyFlood.responseTime'),
      [t('portfolioItems.projectDetailsLabels.location')]: 'South Shore',
      [t('portfolioItems.projectDetailsLabels.duration')]: '3 Days',
      [t('portfolioItems.projectDetailsLabels.serviceType')]: t('portfolioItems.emergencyFlood.serviceType')
    }
  },
  {
    id: 'carpet-cleaning-residential',
    title: t('portfolioItems.carpetCleaning.title'),
    category: t('portfolioItems.carpetCleaning.category'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/residential-carpet-cleaning.jpg',
    date: '4 Apr',
    likes: 183,
    description: t('portfolioItems.carpetCleaning.description'),
    content: t('portfolioItems.carpetCleaning.content'),
    beforeAfter: true,
    projectDetails: {
      [t('portfolioItems.projectDetailsLabels.client')]: t('portfolioItems.carpetCleaning.client'),
      [t('portfolioItems.projectDetailsLabels.location')]: 'West Island',
      [t('portfolioItems.projectDetailsLabels.duration')]: '4 Hours',
      [t('portfolioItems.projectDetailsLabels.serviceType')]: t('portfolioItems.carpetCleaning.serviceType')
    }
  },
  {
    id: 'commercial-carpet-cleaning-restaurant',
    title: t('portfolioItems.commercialCarpet.title'),
    category: t('portfolioItems.commercialCarpet.category'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_3428-scaled.jpg',
    date: '4 Apr',
    likes: 195,
    description: t('portfolioItems.commercialCarpet.description'),
    content: t('portfolioItems.commercialCarpet.content'),
    beforeAfter: false,
    projectDetails: {
      [t('portfolioItems.projectDetailsLabels.client')]: t('portfolioItems.commercialCarpet.client'),
      [t('portfolioItems.projectDetailsLabels.location')]: 'Laval',
      [t('portfolioItems.projectDetailsLabels.duration')]: '1 Night',
      [t('portfolioItems.projectDetailsLabels.serviceType')]: t('portfolioItems.commercialCarpet.serviceType')
    }
  },
  {
    id: 'electrostatic-cleaning-visha',
    title: t('portfolioItems.electrostaticCleaning.title'),
    category: t('portfolioItems.electrostaticCleaning.category'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/ElectroStatic-Cleaning-AP-Pacific.png',
    date: '12 Dec',
    likes: 207,
    description: t('portfolioItems.electrostaticCleaning.description'),
    content: t('portfolioItems.electrostaticCleaning.content'),
    beforeAfter: false,
    projectDetails: {
      [t('portfolioItems.projectDetailsLabels.client')]: t('portfolioItems.electrostaticCleaning.client'),
      [t('portfolioItems.projectDetailsLabels.location')]: 'Montreal',
      [t('portfolioItems.projectDetailsLabels.duration')]: '4 Hours',
      [t('portfolioItems.projectDetailsLabels.serviceType')]: t('portfolioItems.electrostaticCleaning.serviceType')
    }
  },
  {
    id: 'commercial-carpet-visha',
    title: t('portfolioItems.commercialCarpet.title'),
    category: t('portfolioItems.commercialCarpet.category'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_4095-scaled.jpg',
    date: '12 Dec',
    likes: 196,
    description: t('portfolioItems.commercialCarpet.description'),
    content: t('portfolioItems.commercialCarpet.content'),
    beforeAfter: true,
    projectDetails: {
      [t('portfolioItems.projectDetailsLabels.client')]: 'Office',
      [t('portfolioItems.projectDetailsLabels.location')]: 'Laval, QC',
      [t('portfolioItems.projectDetailsLabels.duration')]: '6 Hours',
      [t('portfolioItems.projectDetailsLabels.serviceType')]: t('portfolioItems.commercialCarpet.serviceType')
    }
  },
  {
    id: 'duct-cleaning-before-after',
    title: t('portfolioItems.ductCleaning.title'),
    category: t('portfolioItems.ductCleaning.category'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/dirty-duct-scaled.jpg',
    imageBefore: 'https://landing.it-tech.name/wp-content/uploads/2025/11/dirty-duct-scaled.jpg',
    imageAfter: 'https://landing.it-tech.name/wp-content/uploads/2025/11/clean-duct-scaled.jpg',
    date: '1 Nov',
    likes: 189,
    description: t('portfolioItems.ductCleaning.description'),
    content: t('portfolioItems.ductCleaning.content'),
    beforeAfter: true,
    projectDetails: {
      [t('portfolioItems.projectDetailsLabels.client')]: t('portfolioItems.ductCleaning.client'),
      [t('portfolioItems.projectDetailsLabels.location')]: 'Montreal, QC',
      [t('portfolioItems.projectDetailsLabels.duration')]: '3 Hours',
      [t('portfolioItems.projectDetailsLabels.serviceType')]: t('portfolioItems.ductCleaning.serviceType')
    }
  }
];

// Keep the static portfolioItems export for backward compatibility
// Note: This returns English keys. Components should use getPortfolioItems(t) instead.
export const portfolioItems = [];

// Function to get translated portfolio categories
export const getPortfolioCategories = (t) => ({
  'All': t('portfolio.categories.all'),
  'Commercial Cleaning': t('portfolio.categories.commercialCleaning'),
  'Carpet Cleaning': t('portfolio.categories.carpetCleaning'),
  'Electrostatic Cleaning': t('portfolio.categories.electrostaticCleaning'),
  'Tile & Grout Cleaning': t('portfolio.categories.tileGroutCleaning'),
  'Air Duct Cleaning': t('portfolio.categories.airDuctCleaning'),
  'Emergency Services': t('portfolio.categories.emergencyServices'),
  'Equipment Showcase': t('portfolio.categories.equipmentShowcase')
});

// Static categories (English keys for filtering)
export const portfolioCategoryKeys = [
  'All',
  'Commercial Cleaning',
  'Carpet Cleaning',
  'Electrostatic Cleaning',
  'Tile & Grout Cleaning',
  'Air Duct Cleaning',
  'Emergency Services',
  'Equipment Showcase'
];